import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-etisalat-consent',
  templateUrl: './etisalat-consent.component.html',
  styleUrls: ['./etisalat-consent.component.scss']
})
export class EtisalatConsentComponent implements OnInit {

  EtisalatConsentForm: any;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  
  constructor( private FB: FormBuilder) { 
    this.EtisalatConsentForm = this.FB.group({
      etisalatConsent: ['', [Validators.required]],
      partnerConsent: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
  }
  get errorControl() {
    return this.EtisalatConsentForm.controls;
  }
  contactFormSubmitted() {
    if (this.EtisalatConsentForm.valid) {
      this.formSubmit.emit(this.EtisalatConsentForm);
    }
  }
}